import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl';

import Page from '../page/page'
import Button from '../button/button'
import ButtonPush from '../button/button-push'
import Switch from '../form/form-switch'
import List from '../list/list'
import * as modules from './components/_index';

import ModuleSchedule from './module-schedule'

import './module.styl'
import './components/components.styl'
class ModulePage extends React.Component {

    constructor(props) {
        super(props)
        this.i18n = 'app.modules.'
        this.state = {
            open: false,
            data: {
        }}
        Object.assign(this.state.data, props);
    }

    scheduling() {
        let { type, optionsDefault } = this.state.data;
        this.state.data.modulesSchedules.push({
            visibility: true,
            type,
            options: Object.create(optionsDefault)
        });

        this.setState(this.state)
    }

    visible(e) {
        this.state.data.visibility = !this.state.data.visibility
        this.setState(this.state)
    }

    header() {
        let { open } = this.state.data
        let { visibility=true, title } = this.state.data

        return <div className="module-page-header">
            <label>{title}</label>
            <ButtonPush onClick={this.visible.bind(this)} value={visibility} iconOn='eye' iconOff='eyeBlocked' />
        </div>
    }

    default(newValue) {
        this.state.data.optionsDefault.isCustom = !this.state.data.optionsDefault.isCustom
        this.setState(this.state)
    }

    body(){
        let { data } = this.state
        let { optionsDefault, modulesSchedules, type, visibility } = data
        let moduleType = modules[type.replace(/-/g, "_")]

        if(!moduleType) {
            throw new Error('type \'' + type + '\' is not define ./components/_index.jsx file')
        }
        return <div className={"module-Property" + (visibility ? '' : ' disabled')}>
            <Switch onChange={ this.default.bind(this) }
                    checked={optionsDefault.isCustom}
                    labelLeft={'app.modules.default'}
                    labelRight={'app.modules.custom'} />

            {optionsDefault.isCustom && React.createElement(moduleType, { onChange: console.log, ...optionsDefault, disabled: false })}

            <Button onClick={this.scheduling.bind(this)} label={this.i18n + 'scheduling'} />

            <List collection={modulesSchedules.map(module => <ModuleSchedule type={type} module={module} />)} label={this.i18n + 'schedules'} />
        </div>
    }
    footer() {
        return <Button onClick={this.props.close} label='app.close' />
    }
    render() {
        return <Page header={this.header()} body={this.body()} footer={this.footer()} />
    }
}

ModulePage.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    visibility: PropTypes.bool.isRequired,
    optionsDefault: PropTypes.object.isRequired,
    modulesSchedules: PropTypes.array.isRequired
}

export default ModulePage;
